module.exports = __webpack_public_path__ + "static/media/sona-sarovar-trust-logo.ceabc13b.jpg";